/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Pricing_HeadingInputs */

const en_platform_pricing_heading = /** @type {(inputs: Platform_Pricing_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free, grow when you want`)
};

const pl_platform_pricing_heading = /** @type {(inputs: Platform_Pricing_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij za darmo, rośnij, kiedy chcesz`)
};

/**
* | output |
* | --- |
* | "Start free, grow when you want" |
*
* @param {Platform_Pricing_HeadingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_pricing_heading = /** @type {((inputs?: Platform_Pricing_HeadingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Pricing_HeadingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_pricing_heading(inputs)
	return en_platform_pricing_heading(inputs)
});